import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { find, flatten, isEqual } from 'lodash-es';
import cn from 'classnames';
import { IconCheck, IconClose } from '../../../../icons';
import { isFunction, safeInvoke, keys, intentClass, isDefined } from '../../../../library';
import { Pane } from '../../../pane';
export var OptionList = function (_React$Component) {
  _inherits(OptionList, _React$Component);
  var _super = _createSuper(OptionList);
  function OptionList(props) {
    var _this;
    _classCallCheck(this, OptionList);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "_optionsParentRef", React.createRef());
    _defineProperty(_assertThisInitialized(_this), "_queryTimer", void 0);
    _defineProperty(_assertThisInitialized(_this), "checkEquality", function (optionA, optionB) {
      var optionIdProp = _this.props.optionIdProp;
      if (optionA === null || optionB === null) {
        return optionA === optionB;
      } else if (isFunction(optionIdProp)) {
        return optionIdProp(optionA) === optionIdProp(optionB);
      } else {
        return optionA[optionIdProp] === optionB[optionIdProp];
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setQuery", function (value) {
      window.clearTimeout(_this._queryTimer);
      _this.setState({
        query: value
      });
      var matches = _this.state.flattenedOptions.filter(isNotOptionHeading).filter(function (option) {
        if (isOptionHeading(option)) return null;
        if (isDefined(_this.props.optionSearchProp) && !isFunction(_this.props.optionSearchProp)) {
          var searchText = option[_this.props.optionSearchProp];
          return typeof searchText === 'string' && searchText.toLowerCase().substring(0, value.length) === value.toLowerCase();
        }
        return null;
      });
      _this._queryTimer = window.setTimeout(function () {
        _this.setState({
          query: ''
        });
      }, 200);
      if (matches.length > 0) {
        return matches[0];
      }
      return null;
    });
    _defineProperty(_assertThisInitialized(_this), "getFocusedIndex", function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.flattenedOptions;
      var focusedOption = _this.state.focusedOption;
      for (var i = 0; i < options.length; ++i) {
        var opt = options[i];
        if (isOptionHeading(opt)) continue;
        if (_this.checkEquality(opt, focusedOption)) {
          return i;
        }
      }
      return -1;
    });
    _defineProperty(_assertThisInitialized(_this), "getFocusedElement", function () {
      if (_this._optionsParentRef == null || _this._optionsParentRef.current === null || _this._optionsParentRef.current.children === null) return null;
      var focusedIndex = _this.getFocusedIndex();
      return _this._optionsParentRef.current.children.item(focusedIndex);
    });
    _defineProperty(_assertThisInitialized(_this), "getFirstEnabledOption", function () {
      var startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var backwards = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var options = _this.state.flattenedOptions;
      var maxIndex = options.length - 1;
      if (options.length === 0 || startIndex > maxIndex || startIndex < 0) {
        return null;
      }
      var index = startIndex;
      do {
        var opt = options[index];
        if (!isOptionHeading(opt) && !isOptionDisabled(opt, _this.props.optionDisabled)) {
          return opt;
        }
        index = backwards ? index - 1 : index + 1;
      } while (index !== startIndex && index <= maxIndex);
      return null;
    });
    _defineProperty(_assertThisInitialized(_this), "getItemsParentPadding", function () {
      var _getComputedStyle = getComputedStyle(_this._optionsParentRef.current),
        paddingTop = _getComputedStyle.paddingTop,
        paddingBottom = _getComputedStyle.paddingBottom;
      return {
        paddingBottom: pxToNumber(paddingBottom),
        paddingTop: pxToNumber(paddingTop)
      };
    });
    _defineProperty(_assertThisInitialized(_this), "scrollFocusedItemIntoView", function () {
      var focusedElement = _this.getFocusedElement();
      console.log(focusedElement);
      if (_this._optionsParentRef.current === null || focusedElement === null) return;
      var activeTop = focusedElement.offsetTop,
        activeHeight = focusedElement.offsetHeight;
      var _this$_optionsParentR = _this._optionsParentRef.current,
        parentOffsetTop = _this$_optionsParentR.offsetTop,
        parentScrollTop = _this$_optionsParentR.scrollTop,
        parentHeight = _this$_optionsParentR.clientHeight;
      var _this$getItemsParentP = _this.getItemsParentPadding(),
        paddingTop = _this$getItemsParentP.paddingTop,
        paddingBottom = _this$getItemsParentP.paddingBottom;
      var activeBottomEdge = activeTop + activeHeight + paddingBottom - parentOffsetTop;
      var activeTopEdge = activeTop - paddingTop - parentOffsetTop;
      if (activeBottomEdge >= parentScrollTop + parentHeight) {
        _this._optionsParentRef.current.scrollTop = activeBottomEdge - parentHeight;
      } else if (activeTopEdge <= parentScrollTop) {
        _this._optionsParentRef.current.scrollTop = activeTopEdge;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "scrollFocusedItemToTop", function () {
      var focusedElement = _this.getFocusedElement();
      if (_this._optionsParentRef.current === null || focusedElement === null) return;
      var activeTop = focusedElement.offsetTop;
      var parentOffsetTop = _this._optionsParentRef.current.offsetTop;
      var _this$getItemsParentP2 = _this.getItemsParentPadding(),
        paddingTop = _this$getItemsParentP2.paddingTop;
      var activeTopEdge = activeTop - paddingTop - parentOffsetTop;
      _this._optionsParentRef.current.scrollTop = activeTopEdge;
    });
    _defineProperty(_assertThisInitialized(_this), "isOptionActive", function (option) {
      return find(_this.props.activeOptions, function (active) {
        return _this.checkEquality(active, option);
      }) !== undefined ? true : false;
    });
    _defineProperty(_assertThisInitialized(_this), "flattenOptions", function (options) {
      return options.reduce(function (acc, cur) {
        if (isOptionGroup(cur)) {
          return [].concat(_toConsumableArray(acc), [{
            label: cur.label,
            type: 'heading'
          }], _toConsumableArray(cur.options));
        } else {
          return [].concat(_toConsumableArray(acc), [cur]);
        }
      }, []);
    });
    _defineProperty(_assertThisInitialized(_this), "handleOptionSelect", function (option, e) {
      if (!isOptionDisabled(option, _this.props.optionDisabled)) {
        safeInvoke(_this.props.onOptionSelect, option, e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleOptionMouseEnter", function (option, e) {
      if (!isOptionDisabled(option, _this.props.optionDisabled)) {
        _this.setState({
          focusedOption: option
        });
      } else {
        _this.setState({
          focusedOption: null
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var keyCode = event.keyCode,
        key = event.key;
      var nextActiveItem = null;
      if ([keys.ALT, keys.ARROW_LEFT, keys.ARROW_RIGHT, keys.BACKSPACE, keys.CAPS_LOCK, keys.CONTROL, keys.DELETE, keys.ESCAPE, keys.META, keys.SHIFT, keys.TAB].indexOf(keyCode) >= 0) return;
      if (event.isDefaultPrevented()) return;
      event.preventDefault();
      event.stopPropagation();
      switch (keyCode) {
        case keys.ARROW_UP:
          nextActiveItem = _this.getNextFocusOption(-1);
          break;
        case keys.ARROW_DOWN:
          nextActiveItem = _this.getNextFocusOption(1);
          break;
        case keys.ENTER:
          if (isDefined(_this.state.focusedOption)) {
            _this.handleOptionSelect(_this.state.focusedOption, event);
          }
          break;
        default:
          nextActiveItem = _this.setQuery(_this.state.query + key);
          break;
      }
      if (nextActiveItem !== null) {
        _this.setFocusOption(nextActiveItem, _this.scrollFocusedItemIntoView);
      }
      safeInvoke(_this.props.onKeyDown, event);
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyUp", function (event) {
      safeInvoke(_this.props.onKeyUp, event);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseOut", function (event) {
      safeInvoke(_this.props.onMouseOut, event);
    });
    _defineProperty(_assertThisInitialized(_this), "renderDefaultNoResults", function () {
      return React.createElement(Pane, {
        padding: [6]
      }, React.createElement("div", {
        className: "t--center t--sm"
      }, "... No Options"));
    });
    _defineProperty(_assertThisInitialized(_this), "renderDefaultOptionList", function (listProps) {
      var noResults = _this.props.noResults;
      var index = 0;
      var items = flatten(listProps.options.map(function (val) {
        if (isOptionGroup(val)) {
          return [React.createElement(OptionGroup, {
            key: "group-".concat(val.label.replace(' ', '-')),
            label: val.label
          })].concat(_toConsumableArray(val.options.map(function (opt) {
            return listProps.renderOption(opt, index++);
          })));
        } else {
          return listProps.renderOption(val, index++);
        }
      })).filter(function (item) {
        return item !== null;
      });
      var focusedItemId = isDefined(_this.state.focusedOption) ? isFunction(_this.props.optionIdProp) ? _this.props.optionIdProp(_this.state.focusedOption) : _this.state.focusedOption[_this.props.optionIdProp] + '' : '';
      if (items.length === 0) return noResults ? noResults : _this.renderDefaultNoResults();
      return React.createElement("div", {
        className: cn('option-list', _this.props.className),
        ref: listProps.optionsParentRef,
        tabIndex: 0,
        onKeyDown: listProps.handleKeyDown,
        onKeyUp: listProps.handleKeyUp,
        onMouseOut: listProps.handleMouseOut,
        style: _this.props.style,
        role: "listbox",
        "aria-activedescendant": focusedItemId ? "".concat(_this.props.id, "-").concat(focusedItemId) : undefined,
        "aria-labelledby": _this.props.labeledBy
      }, items);
    });
    _defineProperty(_assertThisInitialized(_this), "renderOption", function (option, index) {
      var focusedOption = _this.state.focusedOption;
      var modifiers = {
        active: _this.isOptionActive(option),
        focused: _this.checkEquality(focusedOption, option),
        disabled: isOptionDisabled(option, _this.props.optionDisabled)
      };
      var id = isFunction(_this.props.optionIdProp) ? _this.props.optionIdProp(option) : option[_this.props.optionIdProp] + '';
      return _this.props.renderOption(option, {
        index: index,
        id: "".concat(_this.props.id, "_").concat(id),
        modifiers: modifiers,
        handleClick: function handleClick(e) {
          return _this.handleOptionSelect(option, e);
        },
        handleMouseEnter: function handleMouseEnter(e) {
          return _this.handleOptionMouseEnter(option, e);
        }
      });
    });
    _this.state = {
      focusedOption: null,
      flattenedOptions: _this.flattenOptions(props.options),
      query: ''
    };
    return _this;
  }
  _createClass(OptionList, [{
    key: "getNextFocusOption",
    value: function getNextFocusOption(direction) {
      var startIndex = this.getFocusedIndex();
      var backwards = direction < 0;
      return this.getFirstEnabledOption(startIndex + direction, backwards);
    }
  }, {
    key: "setFocusOption",
    value: function setFocusOption(focusedOption, callback) {
      this.setState({
        focusedOption: focusedOption
      }, callback);
      safeInvoke(this.props.onFocusedOptionChange, focusedOption);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!isEqual(prevProps.options, this.props.options)) {
        this.setState({
          flattenedOptions: this.flattenOptions(this.props.options)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        options = _this$props.options,
        _this$props$renderOpt = _this$props.renderOptionList,
        renderOptionList = _this$props$renderOpt === void 0 ? this.renderDefaultOptionList : _this$props$renderOpt;
      return renderOptionList({
        options: options,
        handleKeyDown: this.handleKeyDown,
        handleKeyUp: this.handleKeyUp,
        handleMouseOut: this.handleMouseOut,
        optionsParentRef: this._optionsParentRef,
        renderOption: this.renderOption
      });
    }
  }]);
  return OptionList;
}(React.Component);
_defineProperty(OptionList, "defaultProps", {
  activeOptions: []
});
function isOptionDisabled(item, optionDisabled) {
  if (optionDisabled === undefined || optionDisabled == null || item == null) {
    return false;
  } else if (isFunction(optionDisabled)) {
    return optionDisabled(item);
  }
  return !!item[optionDisabled];
}
function pxToNumber(value) {
  return value == null ? 0 : parseInt(value.slice(0, -2), 10);
}
var OptionGroup = function OptionGroup(props) {
  return React.createElement("div", {
    className: "option-header"
  }, props.label);
};
export function isOptionGroup(val) {
  return Object.hasOwnProperty.call(val, 'type') && Object.hasOwnProperty.call(val, 'options') && val.type === 'group';
}
export function isOptionHeading(val) {
  return Object.hasOwnProperty.call(val, 'type') && val.type === 'heading';
}
export function isNotOptionHeading(val) {
  return !Object.hasOwnProperty.call(val, 'type') || val.type !== 'heading';
}
export var OptionItem = function OptionItem(props) {
  var classNames = cn('option-item', {
    '-active': props.isActive,
    '-focused': props.isFocused,
    '-disabled': props.isDisabled
  }, intentClass(props.isActive ? 'primary' : 'none'));
  var handleClick = function handleClick(e) {
    safeInvoke(props.onClick, e);
  };
  var handleMouseOver = function handleMouseOver(e) {
    safeInvoke(props.onMouseOver, e);
  };
  return React.createElement("div", {
    id: props.id,
    className: classNames,
    onClick: handleClick,
    onMouseOver: handleMouseOver,
    role: "option",
    "aria-selected": props.isActive
  }, React.createElement("span", {
    className: "option-item__text"
  }, props.children), React.createElement("span", {
    className: "option-item__status",
    "aria-hidden": "true"
  }, React.createElement(IconCheck, {
    className: "option-check",
    title: "selected"
  }), React.createElement(IconClose, {
    className: "option-remove",
    title: "remove"
  })));
};